function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  padding: ",
        ";\n  border-bottom: ",
        ";\n  border-color: ",
        ";\n  cursor: pointer;\n  transition: all 0.2s;\n  border-radius: 0.5rem;\n\n  &:hover {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  background-color: transparent;\n  pointer-events: none;\n  border-radius: 0.5rem;\n  transition: background-color 0.2s;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  padding: 0.5rem;\n  border-radius: 0.5rem;\n  transition: all 0.2s;\n  background-color: ",
        ";\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);\n  position: relative;\n  \n  &:hover {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  width: 100%;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  width: 6rem;\n  height: 6rem;\n  background-color: ",
        ";\n  position: relative;\n  flex-shrink: 0;\n  overflow: hidden;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #9ca3af;\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: ",
        ";\n  left: ",
        ";\n  transform: ",
        ";\n  transform-origin: top left;\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  flex: 1;\n  padding: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  height: 6rem;\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.75rem;\n  color: ",
        ";\n  font-weight: 500;\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  margin-left: 0.25rem;\n  color: #3b82f6;\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  margin-left: 0.25rem;\n  color: #f59e0b;\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n  z-index: 50;\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  cursor: pointer;\n  outline: none;\n  transition: all 0.2s ease-in-out;\n  \n  padding: ",
        ";\n  border-radius: 9999px;\n  background-color: ",
        ";\n  color: ",
        ";\n  box-shadow: ",
        ";\n  \n  &:hover {\n    opacity: 0.8;\n  }\n  \n  &:active {\n    transform: scale(0.95);\n  }\n  \n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0.25rem;\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  font-weight: 500;\n  font-size: ",
        ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  margin-top: 0.125rem;\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  margin-top: auto;\n  padding-top: 0.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: ",
        ";\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  font-size: 0.75rem;\n  padding-left: ",
        ";\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  border-radius: 0.5rem;\n  overflow: hidden;\n  border: 1px solid;\n  border-color: ",
        ";\n  aspect-ratio: 16/9;\n  background-color: ",
        ";\n  position: relative;\n  margin-bottom: 0.75rem;\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.75rem;\n  color: ",
        ";\n  align-self: center;\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem;\n  color: ",
        ";\n  font-weight: 500;\n  \n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
// 카드 컨테이너 스타일
export var CardContainer = styled.div(_templateObject(), function(props) {
    return props.isCompact ? '0' : '1rem';
}, function(props) {
    return props.isCompact ? 'none' : '1px solid';
}, function(param) {
    var theme = param.theme;
    return theme.isDark ? '#1f2937' : '#e5e7eb';
}, function(param) {
    var theme = param.theme;
    return theme.isDark ? 'rgba(17, 24, 39, 0.3)' : '#f9fafb';
});
export var HoverBackground = styled.div(_templateObject1());
export var CompactCardContainer = styled.div(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.isDark ? '#111827' : 'white';
});
export var CompactContent = styled.div(_templateObject3());
export var CompactImageContainer = styled.div(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.isDark ? '#1f2937' : '#f3f4f6';
});
export var PlaceholderIcon = styled.div(_templateObject5());
export var ThumbnailImage = styled.img(_templateObject6());
export var CategoryBadgeContainer = styled.div(_templateObject7(), function(props) {
    return props.isCompact ? '0.25rem' : '0.5rem';
}, function(props) {
    return props.isCompact ? '0.25rem' : '0.5rem';
}, function(props) {
    return props.isCompact ? 'scale(0.75)' : 'none';
});
export var CompactContentContainer = styled.div(_templateObject8());
export var CompactHeader = styled.div(_templateObject9());
export var AuthorInfo = styled.div(_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.isDark ? '#9ca3af' : '#6b7280';
});
export var VerifiedBadge = styled.span(_templateObject11());
export var FeaturedBadge = styled.span(_templateObject12());
export var MenuButtonContainer = styled.div(_templateObject13(), function(props) {
    return props.isDefault ? '0.5rem' : '0.25rem';
}, function(props) {
    return props.isDefault ? '0.5rem' : '0.25rem';
});
export var MenuButton = styled.button(_templateObject14(), function(props) {
    return props.isDefault ? '0.375rem' : '0.25rem';
}, function(param) {
    var theme = param.theme, isDefault = param.isDefault;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? isDefault ? 'rgba(17, 24, 39, 0.9)' : 'rgba(17, 24, 39, 0.8)' : isDefault ? 'rgba(255, 255, 255, 0.9)' : 'rgba(255, 255, 255, 0.8)';
}, function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? '#d1d5db' : '#4b5563';
}, function(props) {
    return props.isDefault ? '0 1px 2px 0 rgba(0, 0, 0, 0.05)' : 'none';
});
export var ProjectInfoContainer = styled.div(_templateObject15());
export var ProjectTitle = styled.h3(_templateObject16(), function(props) {
    return props.$isCompact ? '0.875rem' : '1.125rem';
});
export var ProjectDescription = styled.p(_templateObject17(), function(param) {
    var theme = param.theme;
    return theme.isDark ? '#d1d5db' : '#4b5563';
}, function(props) {
    return props.$isCompact ? '0.75rem' : '0.875rem';
}, function(props) {
    return props.$isCompact ? 'display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow: hidden;' : 'margin-top: 0.25rem;';
});
export var StatsContainer = styled.div(_templateObject18(), function(props) {
    return props.$isCompact ? '0.75rem' : '0.875rem';
});
export var DateInfo = styled.div(_templateObject19(), function(param) {
    var theme = param.theme;
    return theme.isDark ? '#9ca3af' : '#6b7280';
}, function(props) {
    return props.$isCompact ? '0.25rem' : '0';
});
export var ThumbnailContainer = styled.div(_templateObject20(), function(param) {
    var theme = param.theme;
    return theme.isDark ? '#1f2937' : '#e5e7eb';
}, function(param) {
    var theme = param.theme;
    return theme.isDark ? '#1f2937' : '#f3f4f6';
});
export var TagsContainer = styled.div(_templateObject21());
export var MoreTags = styled.span(_templateObject22(), function(param) {
    var theme = param.theme;
    return theme.isDark ? '#9ca3af' : '#6b7280';
});
export var ActionContainer = styled.div(_templateObject23());
export var ViewMoreButton = styled.button(_templateObject24(), function(param) {
    var theme = param.theme;
    return theme.isDark ? '#93c5fd' : '#2563eb';
});
